import React from "react";
import { useTheme } from "../../../ThemeContext";

const SectionDropdown = ({ value = [], onChange }) => {
  const { theme } = useTheme();

  // Options for the dropdown
  const options = [
    { label: "S1 - Site", value: "S1 - Site" },
    { label: "S2 - Site", value: "S2 - Site" },
    { label: "S1 - CY", value: "S1 - CY" },
    { label: "S2 - CY", value: "S2 - CY" },
    { label: "S1 - Er", value: "S1 - Er" },
    { label: "S2 - Er", value: "S2 - Er" },
  ];

  // Handle changes in the multi-select
  const handleChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(
      (option) => option.value
    );
    onChange(selectedOptions); // Pass the array of selected values to the parent
  };

  return (
    <div>
      <label
        htmlFor="section-dropdown"
        className={`block mb-2 text-sm font-medium ${
          theme === "dark" ? "text-white" : "text-gray-700"
        }`}
      >
        Select Sections
      </label>
      <select
        id="section-dropdown"
        value={value}
        multiple
        onChange={handleChange}
        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${
          theme === "dark" ? "bg-gray-700 text-white border-gray-600" : ""
        }`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SectionDropdown;
